module.exports = __webpack_public_path__ + "static/media/kevin-fitzgerald-479720.1202e3e1.jpg";